import React, { useState } from "react";
import { normalPriceCount } from "../../env";
import ErrorAction from "../../components/Modal/ErrorAction";
import PostReq from "../../utils/PostReq";
const ShemshRow = ({ data, setData, index }) => {
  const [EditMode, setEditMode] = useState(false);
  const [DeletePop, setDeletePop] = useState(false);
  const [Changes, setChanges] = useState("");
  const handleChange = (property, value) => {
    setChanges((prevState) => ({
      ...prevState,
      [property]: value,
    }));
  };
  const UpdateRow = async () => {
    const result = await PostReq({
      method: "Post",
      url: "/xtra/update-shemsh",
      body: { id: data._id, ...Changes },
    });
    setData(result.filter);
    setEditMode(false);
  };
  const DeleteRow = async () => {
    const result = await PostReq({
      method: "Post",
      url: "/xtra/remove-shemsh",
      body: { id: data._id },
    });
    setData(result.filter);
  };
  console.log(Changes);
  return (
    <>
      <tr>
        <td>{index}</td>
        <td>
          {!EditMode ? (
            <div className="order-num">
              <p>{data.from}</p>
            </div>
          ) : (
            <div className="order-num">
              <input
                type="number"
                className="input-number"
                defaultValue={data.from}
                onChange={(e) => handleChange("from", e.target.value)}
              />
            </div>
          )}
        </td>
        <td>
          {!EditMode ? (
            <div className="order-num">
              <p>{data.to}</p>
            </div>
          ) : (
            <div className="order-num">
              <input
                type="number"
                className="input-number"
                defaultValue={data.to}
                onChange={(e) => handleChange("to", e.target.value)}
              />
            </div>
          )}
        </td>
        <td>
          {!EditMode ? (
            <div className="order-num">
              <p>{normalPriceCount(data.price)}</p>
            </div>
          ) : (
            <div className="order-num">
              <input
                type="number"
                className="input-number"
                style={{ width: "100px" }}
                defaultValue={data.price}
                onChange={(e) => handleChange("price", e.target.value)}
              />
            </div>
          )}
        </td>
        <td>
          {!EditMode ? (
            <div className="more-btn">
              <i
                className="tableIcon fas fa-edit"
                onClick={() => setEditMode(true)}
              ></i>
              <i
                className="tableIcon fas fa-trash"
                style={{ color: "#ff0000" }}
                onClick={() => setDeletePop(data._id)}
              ></i>
            </div>
          ) : (
            <div className="more-btn">
              <i className="tableIcon fas fa-check" onClick={UpdateRow}></i>
              <i
                className="tableIcon fas fa-remove"
                style={{ color: "#ff0000" }}
                onClick={() => setEditMode(false)}
              ></i>
            </div>
          )}
        </td>
      </tr>

      {DeletePop ? (
        <ErrorAction
          text={"آیا این شمش حذف شود؟"}
          buttonText={"حذف"}
          color={"red"}
          close={() => setDeletePop(false)}
          action={DeleteRow}
        />
      ) : (
        <></>
      )}
    </>
  );
};

export default ShemshRow;
